import type { LargeAreaCode } from '../graphql/scalars'

export function ikyuDayRegionalPagePath(largeAreaCode: LargeAreaCode): string {
  const eastLargeAreaCodes = [
    '01', // 北海道
    '02', // 東北
    '03', // 関東
    '04', // 甲信越
  ]
  const region = eastLargeAreaCodes.includes(largeAreaCode) ? 'east' : 'west'

  return `/specials/19-days?region=${region}`
}

if (import.meta.vitest) {
  const { expect, it } = import.meta.vitest

  it('returns the path for east', () => {
    expect(ikyuDayRegionalPagePath('04' as LargeAreaCode)).toBe('/specials/19-days?region=east')
  })

  it('returns the path for west', () => {
    expect(ikyuDayRegionalPagePath('05' as LargeAreaCode)).toBe('/specials/19-days?region=west')
  })
}
